module.exports = __webpack_public_path__ + "static/media/americana.1f506c54.png";